module.exports = __webpack_public_path__ + "static/product_3_month-340aae9b15b28c0f46cf92748c3a0480.png";